__turbopack_context__.v({
  "dropDown": "DropDownWithPrice-module-scss-module__wJbVqq__dropDown",
  "price": "DropDownWithPrice-module-scss-module__wJbVqq__price",
  "selectWrap": "DropDownWithPrice-module-scss-module__wJbVqq__selectWrap",
  "typeAndPrice": "DropDownWithPrice-module-scss-module__wJbVqq__typeAndPrice",
  "visuallyHidden": "DropDownWithPrice-module-scss-module__wJbVqq__visuallyHidden",
});
